'use client'

// BAO-125 Phase 5a: the CPRA "Your Privacy Choices" link.
//
// On marketing routes the banner is mounted, so the link reopens it in place.
// Anywhere else (signup, settings) it navigates to the cookie policy with
// `?choices=1`, which opens the banner there.
import * as React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { isMarketingPath } from '@/lib/analytics/marketing-routes'
import { openConsentBanner } from '@/lib/analytics/use-consent'

export function PrivacyChoicesLink({
  className,
  children = 'Your Privacy Choices',
}: {
  className?: string
  children?: React.ReactNode
}) {
  const pathname = usePathname()
  const onMarketing = isMarketingPath(pathname || '/')

  if (onMarketing) {
    return (
      <button type="button" onClick={openConsentBanner} className={className} data-testid="privacy-choices">
        {children}
      </button>
    )
  }
  return (
    <Link href="/legal/cookies?choices=1" className={className} data-testid="privacy-choices">
      {children}
    </Link>
  )
}
